module.exports = __webpack_public_path__ + "img/library_article.630a1f14.svg";